export default __webpack_public_path__ + "static/media/login-image.d5fb0bdf.svg";